import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import BackgroundImg from '../../media/background.png';

const getAdPlaceholderStyles = () => ({
  background: {
    width: '100%',
    minHeight: '860px',
    display: 'flex',
    justifyContent: 'center',
    background: `url("${BackgroundImg}") no-repeat`,
    backgroundSize: 'cover',
    paddingBottom: 80,
  },
  'background-s': {
    paddingBottom: 24,
  },
  adPreviewPlaceholderContainer: {
    width: '98vw',
    overflow: 'hidden',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  },
});

// Lazy load the AdPreviewPlaceholder component
const AdPreviewPlaceholder = React.lazy(() => import('@bingads-webui-campaign-react/pmax-landing-ad-preview').then(module => ({
  default: module.AdPreviewPlaceholder,
})));

export function DelayedAdPreviewPlaceholder({
  showAdPreviewPlaceholder, websiteInputRef, methodsContainerRef, logger,
}) {
  const classes = useDefaultStyles(getAdPlaceholderStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  if (!showAdPreviewPlaceholder) {
    return null;
  }

  return (
    <div className={classNames('landing-page-ad-preview-placeholder', classes.background, classes[`background-${displayMode}`])}>
      <div className={classNames('ad-preview-placeholder-container', classes.adPreviewPlaceholderContainer, classes[`adPreviewPlaceholderContainer-${displayMode}`])}>
        <Suspense fallback={null}>
          <AdPreviewPlaceholder
            websiteInputRef={websiteInputRef}
            methodsContainerRef={methodsContainerRef}
            logger={logger}
          />
        </Suspense>
      </div>
    </div >
  );
}

DelayedAdPreviewPlaceholder.propTypes = {
  showAdPreviewPlaceholder: PropTypes.bool,
  websiteInputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  methodsContainerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }).isRequired,
};

DelayedAdPreviewPlaceholder.defaultProps = {
  showAdPreviewPlaceholder: true,
  websiteInputRef: { current: null },
  methodsContainerRef: { current: null },
};
